var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 38,
    viewBox: "0 0 33 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36_3458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2401 0.537364C22.2966 1.52828 27.912 5.9232 30.2662 10.731C33.8663 18.0803 32.5197 26.4297 26.8127 32.1551C22.6447 36.339 16.7637 38.4768 11.6339 37.6602C6.95289 36.917 3.43528 33.5956 5.5147 31.8706C6.00936 31.4577 6.54983 31.5954 8.83078 32.7056C12.3667 34.4305 15.2156 34.4947 18.4951 32.9441C21.1149 31.7055 24.1654 28.6043 25.6402 25.6866C28.2326 20.5485 26.7761 13.7313 22.1867 9.48317C19.9974 7.45546 18.5683 6.74897 15.3622 6.08835C12.3759 5.48279 9.81095 5.78557 7.32847 7.06092C1.57571 10.0062 1.4383 17.7959 7.07197 21.6862C8.85826 22.9157 9.43537 23.1083 11.3133 23.0808C13.8599 23.0441 14.7118 22.4569 15.8294 19.9704C16.8279 17.75 16.5164 16.5205 14.7759 15.7865C13.1545 15.0984 12.4492 15.392 10.9652 17.3463C8.96819 19.9704 7.63992 18.6767 8.79414 15.2452C9.80179 12.2541 11.3316 10.9604 13.8507 10.9604C16.0675 10.9604 17.4233 11.5568 18.9164 13.1808C20.3913 14.7773 20.7852 15.7315 20.7852 17.6491C20.7852 19.7869 19.1729 23.1083 17.5424 24.3378C16.8737 24.8424 15.3622 25.5306 14.1896 25.8701C11.643 26.6041 8.3178 26.2095 6.26586 24.9342C4.71774 23.9708 2.49175 21.5577 1.65815 19.9337C0.668822 18.0161 -0.192259 13.6395 0.0550726 11.7678C0.806229 6.05165 5.55134 1.55581 11.8995 0.528189C14.7026 0.0786044 14.9042 0.0786044 17.2401 0.537364Z",
    fill: "#EAE6DC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36_3458"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.2631,
    height: 37.6458,
    fill: "white",
    transform: "translate(0 0.188232)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.9522489f589470c5759bb645a9caeac1.svg";
export { ForwardRef as ReactComponent };